exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.wrapper[data-v-35221b26] {\r\n  background-color: #f7f7f7;\n}\r\n", "", {"version":3,"sources":["C:/workspace/replenishment/src/main/ui-src/src/components/page/Config.vue"],"names":[],"mappings":";AACA;EACE,0BAA0B;CAC3B","file":"Config.vue","sourcesContent":["\n.wrapper[data-v-35221b26] {\r\n  background-color: #f7f7f7;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-35221b26","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/page/Config.vue
// module id = iPFY
// module chunks = 1